import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the GooglemapProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GooglemapProvider {

  constructor(public http: HttpClient) {
    console.log('Hello GooglemapProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/googlemap/googlemap.ts